export default __webpack_public_path__ + "static/media/Truck Platooning.4440a99d.pdf";